import PlanRecord from 'records/plan';
import { createSymbols } from 'utils/helpers';
import { collectionReducer } from 'utils/reducerGenerator';

export const { TOGGLE_MODAL } = createSymbols(['TOGGLE_MODAL']);

const toggleModal = (state, { selectedPlan }) => {
    return state
        .set('showModal', !state.get('showModal'))
        .set('selectedPlan', selectedPlan);
};

export const { reducer, types } = collectionReducer(
    { namespace: 'PLAN', transformer: PlanRecord },
    { [TOGGLE_MODAL]: toggleModal }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/plans/reducer.js